import React from 'react';
import type { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd';
import CheckoutAdvantages from '../checkout-components/CheckoutAdvantages';
import { useBuilderStore } from '../../../store/checkoutBuilder/BuilderContext';

interface AdvantagesAdapterProps {
  componentId: string;
  selected: boolean;
  dragHandleProps?: DraggableProvidedDragHandleProps | null;
}

const AdvantagesAdapter: React.FC<AdvantagesAdapterProps> = ({ componentId, selected, dragHandleProps }) => {
  const { state, selectNode, deleteNode, duplicateNode } = useBuilderStore();
  const component = state.document.nodes[componentId];

  if (!component || component.type !== 'component') {
    return null;
  }

  return (
    <CheckoutAdvantages
      selected={selected}
      config={component.props || {}}
      onSelect={() => selectNode(componentId)}
      onDelete={() => {
        if (window.confirm('Tem certeza que deseja excluir as vantagens?')) {
          deleteNode(componentId);
        }
      }}
      onDuplicate={() => duplicateNode(componentId)}
      dragHandleProps={dragHandleProps}
    />
  );
};

export default AdvantagesAdapter;
